import {PageHeader, TabsComponent} from '@/components/molecules';
import {FONT_SIZE} from '@/utils/constants/globalStyle';
import {OverviewTab} from '@/containers/ClubPlus/Tabs';
import {TierTab} from '@/containers/ClubPlus/Tabs/TierTab/TierTab';
import {useIntl} from 'react-intl';
import {useActiveTiers} from '@/containers/ClubPlus/hooks/useActiveTiers';
import './_home.scss';
import {useState} from 'react';

export const ClubPlusHome = () => {
  const {formatMessage} = useIntl();
  const {tiers} = useActiveTiers();
  const [resetPageIndexFlag, setResetPageIndexFlag] = useState(0);

  const handleTabChange = () => {
    setResetPageIndexFlag((flag) => flag + 1);
  };

  const overviewTab = [
    {
      id: 'overview',
      tabLabel: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      title: formatMessage({id: 'CLUB_PLUS.TIER_OVERVIEW_TAB_LABEL'}),
      tabComponent: <OverviewTab />
    }
  ];

  const tierTabs = tiers
    ? tiers.map((tier) => ({
        id: tier.name.toLowerCase(),
        tabLabel: tier.name,
        title: tier.name,
        tabComponent: (
          <TierTab
            key={`${tier.tierID}-${resetPageIndexFlag}`}
            tierID={tier.tierID}
            tierName={tier.name}
          />
        )
      }))
    : [];

  const tabList = [...overviewTab, ...tierTabs];

  return (
    <section>
      <div className='header-style'>
        <PageHeader
          title={formatMessage({id: 'CLUB_PLUS.TITLE'})}
          fontSize={FONT_SIZE.XXXL}
        />
      </div>
      <TabsComponent tabList={tabList} onTabChange={handleTabChange} />
    </section>
  );
};
